import { MapPin, Bed, Bath, Square } from "lucide-react";

const PropertyShowcase = () => {
  const properties = [
    {
      id: 1,
      title: "Modern Downtown Penthouse",
      location: "Manhattan, NY",
      price: "$2,450,000",
      beds: 3,
      baths: 2,
      sqft: "2,400",
      image: "https://images.pexels.com/photos/1510173/pexels-photo-1510173.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      featured: true,
    },
    {
      id: 2,
      title: "Minimalist Studio Loft",
      location: "Brooklyn, NY",
      price: "$895,000",
      beds: 1,
      baths: 1,
      sqft: "850",
      image: "https://images.pexels.com/photos/1669799/pexels-photo-1669799.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      featured: false,
    },
    {
      id: 3,
      title: "Luxury Waterfront Villa",
      location: "Miami Beach, FL",
      price: "$4,200,000",
      beds: 5,
      baths: 4,
      sqft: "5,200",
      image: "https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      featured: false,
    },
  ];

  return (
    <section id="properties" className="py-24 lg:py-32 bg-slate-50" data-testid="property-showcase">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-12">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C04000] mb-4 block">
            Featured Listings
          </span>
          <h2 
            className="text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid="properties-heading"
          >
            Explore Verified Properties
          </h2>
          <p className="text-slate-600 max-w-2xl">
            Every property listed has been verified on our blockchain ledger, ensuring transparent ownership history and authentic listings.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-8">
          {/* Featured Property - 8 columns */}
          <div className="md:col-span-8" data-testid="featured-property">
            <div className="property-card bg-white rounded-lg overflow-hidden shadow-sm border border-slate-200 h-full">
              <div className="relative h-[300px] lg:h-[400px] overflow-hidden">
                <img
                  src={properties[0].image}
                  alt={properties[0].title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-[#C04000] text-white text-xs font-semibold px-3 py-1 rounded-full">
                    Featured
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 image-overlay p-6">
                  <p className="text-white text-2xl font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    {properties[0].price}
                  </p>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-slate-900 mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  {properties[0].title}
                </h3>
                <div className="flex items-center text-slate-500 mb-4">
                  <MapPin className="w-4 h-4 mr-1" />
                  <span className="text-sm">{properties[0].location}</span>
                </div>
                <div className="flex items-center gap-6 text-sm text-slate-600">
                  <div className="flex items-center gap-1">
                    <Bed className="w-4 h-4" />
                    <span>{properties[0].beds} Beds</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Bath className="w-4 h-4" />
                    <span>{properties[0].baths} Baths</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Square className="w-4 h-4" />
                    <span>{properties[0].sqft} sqft</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Side Properties - 4 columns */}
          <div className="md:col-span-4 flex flex-col gap-6 lg:gap-8">
            {properties.slice(1).map((property) => (
              <div 
                key={property.id} 
                className="property-card bg-white rounded-lg overflow-hidden shadow-sm border border-slate-200 flex-1"
                data-testid={`property-card-${property.id}`}
              >
                <div className="relative h-[160px] overflow-hidden">
                  <img
                    src={property.image}
                    alt={property.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute bottom-0 left-0 right-0 image-overlay p-4">
                    <p className="text-white text-lg font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>
                      {property.price}
                    </p>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-base font-semibold text-slate-900 mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    {property.title}
                  </h3>
                  <div className="flex items-center text-slate-500 mb-2">
                    <MapPin className="w-3 h-3 mr-1" />
                    <span className="text-xs">{property.location}</span>
                  </div>
                  <div className="flex items-center gap-4 text-xs text-slate-600">
                    <span>{property.beds} Beds</span>
                    <span>{property.baths} Baths</span>
                    <span>{property.sqft} sqft</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PropertyShowcase;
